export default __webpack_public_path__ + "static/media/dlr.ccb6d63e.png";